import { useContext } from 'react';

import HistoryRouterContext, { HistoryRouterContextValues } from './context';

const useHistoryRouter = (): HistoryRouterContextValues =>
    useContext(HistoryRouterContext);

export default useHistoryRouter;
